<template>
    <pre class="code-block"><code v-html="highlightedCode" :class="`sample language-${language}`"></code></pre>
</template>

<script>
  import Prism from 'prismjs';

  export default {
    name: 'CodeBlock',

    props: {
      language: {
        type:     String,
        required: true,
      },

      code: {
        type:    String,
        default: '',
      },
    },

    computed: {
      highlightedCode () {
        return this.highlight(this.code, this.language);
      },
    },

    methods: {
      highlight ( code, language ) {
        return Prism.highlight(code, Prism.languages[ language ], language);
      },
    },
  };
</script>

<style>
    .code-block {
        padding:       1rem;
        border-radius: 4px;
        overflow:      auto;
        max-height:    75vh;
        background:    var(--color-white);
    }

    .code-block .sample {
    }

    .code-block .sample::selection,
    .code-block .sample .token::selection {
        background:  var(--color-green);
        color:       var(--color-white-bright);
        text-shadow: none;
    }

    .sample[class*="language-"],
    .code-block[class*="language-"] {
        color:           black;
        background:      none;
        text-shadow:     0 1px white;
        font-family:     Consolas, Monaco, 'Andale Mono', 'Ubuntu Mono', monospace;
        font-size:       1em;
        text-align:      left;
        white-space:     pre-wrap;
        word-spacing:    normal;
        word-break:      break-all;
        word-wrap:       normal;
        line-height:     1.5;

        -moz-tab-size:   4;
        -o-tab-size:     4;
        tab-size:        4;

        -webkit-hyphens: none;
        -moz-hyphens:    none;
        -ms-hyphens:     none;
        hyphens:         none;
    }

    .code-block[class*="language-"]::-moz-selection,
    .code-block[class*="language-"] ::-moz-selection,
    .sample[class*="language-"]::-moz-selection,
    .sample[class*="language-"] ::-moz-selection {
        text-shadow: none;
        background:  #b3d4fc;
    }

    .code-block[class*="language-"]::selection,
    .code-block[class*="language-"] ::selection,
    .sample[class*="language-"]::selection,
    .sample[class*="language-"] ::selection {
        text-shadow: none;
        background:  #b3d4fc;
    }

    @media print {
        .sample[class*="language-"],
        .code-block[class*="language-"] {
            text-shadow: none;
        }
    }

    /* Code blocks */
    .code-block[class*="language-"] {
        padding:  1em;
        margin:   .5em 0;
        overflow: auto;
    }

    :not(pre) > .sample[class*="language-"],
    .code-block[class*="language-"] {
        background: var(--color-white);
    }

    /* Inline code */
    :not(pre) > .sample[class*="language-"] {
        padding:       .1em;
        border-radius: .3em;
        white-space:   normal;
    }

    .code-block .token.comment,
    .code-block .token.prolog,
    .code-block .token.doctype,
    .code-block .token.cdata {
        color: slategray;
    }

    .code-block .token.punctuation {
        color: #999999;
    }

    .code-block .namespace {
        opacity: .7;
    }

    .code-block .token.property,
    .code-block .token.tag,
    .code-block .token.boolean,
    .code-block .token.number,
    .code-block .token.constant,
    .code-block .token.symbol,
    .code-block .token.deleted {
        color: #990055;
    }

    .code-block .token.selector,
    .code-block .token.attr-name,
    .code-block .token.string,
    .code-block .token.char,
    .code-block .token.builtin,
    .code-block .token.inserted {
        color: #669900;
    }

    .code-block .token.operator,
    .code-block .token.entity,
    .code-block .token.url,
    .code-block .language-css .token.string,
    .code-block .style .token.string {
        background: none;
        color:      #9a6e3a;
    }

    .code-block .token.atrule,
    .code-block .token.attr-value,
    .code-block .token.keyword {
        color: #0077aa;
    }

    .code-block .token.function,
    .code-block .token.class-name {
        color: #dd4a68;
    }

    .code-block .token.regex,
    .code-block .token.important,
    .code-block .token.variable {
        color: #ee9900;
    }

    .code-block .token.important,
    .code-block .token.bold {
        font-weight: bold;
    }

    .code-block .token.italic {
        font-style: italic;
    }

    .code-block .token.entity {
        cursor: help;
    }
</style>
